import { Message } from '@gonfalon/messages/Message';
import { IconButton, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { getKeyboardShortcutLabel, KeyboardShortcut } from '../keyboardShortcuts';

import { useSidebarContext } from './useSidebarContext';

import styles from './SidebarToggle.module.css';

export function SidebarToggle() {
  const sidebar = useSidebarContext();

  return (
    <TooltipTrigger>
      <IconButton
        size="medium"
        variant="minimal"
        aria-label={sidebar.isVisible ? 'Hide sidebar' : 'Show sidebar'}
        icon={sidebar.isVisible ? 'sidebar-left-collapse' : 'sidebar-left-expand'}
        onPress={() => sidebar.toggle({ trigger: 'button' })}
      />
      <Tooltip placement="bottom">
        <span className={styles.tooltip}>
          {sidebar.isVisible ? (
            <>
              <Message id="chrome.sidebar.hide" />
              <kbd>{getKeyboardShortcutLabel(KeyboardShortcut.TOGGLE_PROJECT_SIDEBAR)}</kbd>
            </>
          ) : (
            <>
              <Message id="chrome.sidebar.show" />
              <kbd>{getKeyboardShortcutLabel(KeyboardShortcut.TOGGLE_PROJECT_SIDEBAR)}</kbd>
            </>
          )}
        </span>
      </Tooltip>
    </TooltipTrigger>
  );
}
